// Types
import { CarFormData } from '@/types/car';
import { ChildFormData } from '@/types/child';
import { CoEntrantFormData } from '@/types/coEntrant';
import { FormType } from '@/types/user';
import { GuestFormData } from '@/types/guest';
import { LocalStorageData } from '@/types/localStorage';
import { PrimaryEntrantFormData } from '@/types/primaryEntrant';

const localStorageKey = 'PCA_PARADE_CLIENT';

export function saveToLocalStorage(formType: FormType.PRIMARY_ENTRANT, value: PrimaryEntrantFormData): void;
export function saveToLocalStorage(formType: FormType.CO_ENTRANT, value: CoEntrantFormData): void;
export function saveToLocalStorage(formType: FormType.CHILD, value: ChildFormData): void;
export function saveToLocalStorage(formType: FormType.GUEST, value: GuestFormData): void;
export function saveToLocalStorage(formType: FormType.CAR, value: CarFormData): void;
export function saveToLocalStorage(formType: FormType, value: PrimaryEntrantFormData | CoEntrantFormData | ChildFormData | GuestFormData | CarFormData): void {
  const serializedLocalStorageData: string | null = localStorage.getItem(localStorageKey);

  if (serializedLocalStorageData !== null) {
    const parsedLocalStorageData: LocalStorageData = JSON.parse(serializedLocalStorageData);
    localStorage.setItem(localStorageKey, JSON.stringify({ ...parsedLocalStorageData, ...{ [formType]: value }, lastUpdated: new Date().toISOString() }));
  } else {
    localStorage.setItem(localStorageKey, JSON.stringify({ [formType]: value, lastUpdated: new Date().toISOString() }));
  }
}

export function getFromLocalStorage(formType: FormType.PRIMARY_ENTRANT): PrimaryEntrantFormData;
export function getFromLocalStorage(formType: FormType.CO_ENTRANT): CoEntrantFormData;
export function getFromLocalStorage(formType: FormType.CHILD): ChildFormData;
export function getFromLocalStorage(formType: FormType.GUEST): GuestFormData;
export function getFromLocalStorage(formType: FormType.CAR): CarFormData;
export function getFromLocalStorage(
  formType: FormType.PRIMARY_ENTRANT | FormType.CO_ENTRANT | FormType.CHILD | FormType.GUEST | FormType.CAR
): PrimaryEntrantFormData | CoEntrantFormData | ChildFormData | GuestFormData | CarFormData | null {
  const serializedLocalStorageData: string | null = localStorage.getItem(localStorageKey);

  if (serializedLocalStorageData !== null) {
    const parsedLocalStorageData: LocalStorageData = JSON.parse(serializedLocalStorageData);
    const parsedLocalStorageDataAtKey: PrimaryEntrantFormData | CoEntrantFormData | ChildFormData | GuestFormData | CarFormData | undefined = parsedLocalStorageData[formType];
    return parsedLocalStorageDataAtKey ?? null;
  } else {
    return null;
  }
}
// @ZACK - TODO: Create validations for all LocalStorage data retrieved to ensure it's not corrupted

export function clearLocalStorageByFormTypeKey(formType: FormType.PRIMARY_ENTRANT | FormType.CO_ENTRANT | FormType.CHILD | FormType.GUEST | FormType.CAR): void {
  const serializedLocalStorageData: string | null = localStorage.getItem(localStorageKey);

  if (serializedLocalStorageData !== null) {
    const parsedLocalStorageData: LocalStorageData = JSON.parse(serializedLocalStorageData);
    delete parsedLocalStorageData[formType];
    localStorage.setItem(localStorageKey, JSON.stringify({ ...parsedLocalStorageData, lastUpdated: new Date().toISOString() }));
  }
}

export function clearAllLocalStorage(): void {
  for (const formType in Object.values(FormType)) {
    localStorage.removeItem(formType);
  }
}

export function clearLocalStorageAtKey(key: FormType.PRIMARY_ENTRANT | FormType.CO_ENTRANT | FormType.CHILD | FormType.GUEST): void {
  const existingLocalStorageData: string | null = localStorage.getItem(localStorageKey);
  if (existingLocalStorageData !== null) {
    const parsedLocalStorageData: LocalStorageData = JSON.parse(existingLocalStorageData);
    delete parsedLocalStorageData[key];
    localStorage.setItem(localStorageKey, JSON.stringify({ ...parsedLocalStorageData, lastUpdated: new Date().toISOString() }));
  }
}
